const accountQueryKeys = {
  all: [{ scope: 'account' }] as const,
  lists: () => [{ ...accountQueryKeys.all[0], entity: 'list' }] as const,
  list: (context: { companyId?: string | null }) => [{ ...accountQueryKeys.lists()[0], ...context }] as const,
  details: () => [{ ...accountQueryKeys.all[0], entity: 'detail' }] as const,
  detail: (context: { companyId?: string | null }, code: string) =>
    [{ ...accountQueryKeys.details()[0], ...context, code }] as const,
  budgets: () => [{ ...accountQueryKeys.all[0], entity: 'budgets' }] as const,
  budget: (context: { companyId?: string | null; budgetingScenarioId?: number | null }) =>
    [{ ...accountQueryKeys.budgets()[0], ...context }] as const
}

export default accountQueryKeys
